import { Box, MenuItem, Select, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { colors } from "../../../theme/palette";
import { InteractionsIcon } from "../../../assets/icons/MUI/DashboardIcons";
import { useInteractions } from "../../../api/queries/dashboard/useQueryInteractions";

import { InteractionBox, InteractionBoxLoader } from "./InteractionBox";
import { Interaction } from "../../../types";

const Interactions = () => {
  const [duration, setDuration] = useState<string>("today");
  const { t } = useTranslation();
  const durationsList = [
    "today",
    "yesterday",
    "PAST_7_DAYS",
    "PAST_14_DAYS",
    "PAST_MONTH",
    "PAST_2_MONTHS",
    "PAST_3_MONTHS",
    "PAST_6_MONTHS",
    "PAST_12_MONTHS",
    "YEAR_TO_DATE",
  ];

  const { interactionsData, isInteractionsDataLoading, isInteractionsDataHasError } = useInteractions(duration);

  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        background: colors.White,
        width: "430px",
        minHeight: "368px",
        padding: "18px 20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "25px",
        }}
      >
        <Typography
          sx={{
            display: "flex",
            alignItems: "center",
            columnGap: "10px",
            color: colors.Black100,
            fontFamily: "Inter",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal",
          }}
        >
          <InteractionsIcon />
          {t("pages.dashboard.interactions")}
        </Typography>
        <Select
          sx={{
            borderRadius: "8px !important",
            width: {
              sm: "180px",
              xs: "100%",
            },
          }}
          value={duration}
          onChange={(event) => setDuration(event.target.value as string)}
        >
          {durationsList.map((duration: string) => (
            <MenuItem value={duration}>{t(`pages.dashboard.${duration}`)}</MenuItem>
          ))}
        </Select>
      </Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "14px" }}>
        {isInteractionsDataLoading && [...Array(4)].map(() => <InteractionBoxLoader />)}
        {!isInteractionsDataLoading &&
          interactionsData?.data?.map((interaction: Interaction, idx: number) => (
            <InteractionBox key={idx} interaction={interaction} duration={duration} />
          ))}

        {(isInteractionsDataHasError || interactionsData?.data?.length === 0) && (
          <Typography variant="body16Regular">{t("pages.dashboard.noStatistics")}</Typography>
        )}
      </Box>
    </Box>
  );
};

export default Interactions;
